import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import AppProvider from 'core/AppProvider';

import Routes from 'Routes';

const App = () => (
  <Router>
    <AppProvider>
      <Routes />
    </AppProvider>
    <Toaster
      toastOptions={{
        style: {
          maxWidth: 'none',
        },
      }}
    />
  </Router>
);

export default App;
